import {logErrorMessages} from "@vue/apollo-util";
import {getApolloClient} from "@/shared/apolloclient/apollo.client.ts";
//@ts-ignore
import TENANT_QUERY from "@@/graphql/tenant/tenant.query.graphql";
//@ts-ignore
import TENANT_AUTH_QUERY from "@@/graphql/tenant/tenant.authenticated.query.graphql";
//@ts-ignore
import TENANT_LANGUAGES_QUERY from "@/shared/graphql/tenant/tenant.languages.query.graphql";
import {AppSettings, TenantData} from "@/shared/models/objects.ts";
import {Tenant} from "@/shared/graphql/types";
import {localStoragePersistSafely} from "@/shared/lib/localStorage.ts";

class AppService {

    loadTenantData = async (lang: string): Promise<TenantData> => {
        try {
            const variables = {
                language: lang,
            };
            const response = await getApolloClient().query({query: TENANT_QUERY, variables: variables, fetchPolicy: 'network-only'});
            if (response.errors == undefined) {
                let data = response.data.tenant;
                const app = new AppSettings(data.app);
                const tenantData = new TenantData(data.name, data.info, data.settings, app, data?.policies?.termsOfService);
                localStoragePersistSafely(`TenantData-${lang}`, JSON.stringify(tenantData)); //Update the localStorage cache
                return tenantData;
            } else {
                logErrorMessages(response.error)
                throw response.error;
            }
        } catch (error) {
            throw error;
        }
    };

    loadAuthenticatedTenantData = async (lang: string): Promise<Tenant> => {
        try {
            const response = await getApolloClient().query({query: TENANT_AUTH_QUERY, variables: {"language": lang}, fetchPolicy: 'network-only'});
            if (response.errors == undefined) {
                return response.data.tenant;
            } else {
                logErrorMessages(response.error)
                throw response.error;
            }
        } catch (error) {
            throw error;
        }
    };

    loadLocalStorageTenantData = async (lang: string): Promise<TenantData> => {
        try {
            const tenantDataLocalStorage = localStorage.getItem(`TenantData-${lang}`);
            return (tenantDataLocalStorage ? JSON.parse(tenantDataLocalStorage) : null) as TenantData;
        } catch (e) {
            localStoragePersistSafely(`TenantData-${lang}`, null) //Clear the localStorage key, might be corrupted (newer class name?)
            return null
        }
    }

    loadSupportedLanguages = async (): Promise<String[]> => {
        try {
            const response = await getApolloClient().query({query: TENANT_LANGUAGES_QUERY, variables: {}, fetchPolicy: 'network-only'});
            if (response.errors == undefined) {
                return response.data.tenant.settings.languages.map(lang => lang.code);
            } else {
                logErrorMessages(response.error)
                throw response.error;
            }
        } catch (e) {
            return ['nl', 'en', 'fr', 'de']
        }
    }
}

export const appService = new AppService();